import { Dialog, Kbd } from '@mgdlead/ui';

import { ALL_SHORTCUTS } from './shortcuts';

/** "?" — a lista de atalhos. Tabela de definição simples, legível por leitor de tela. */
export function ShortcutsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title="Atalhos do teclado" size="md">
      <dl className="flex flex-col divide-y divide-border">
        {ALL_SHORTCUTS.map((shortcut) => (
          <div
            key={shortcut.keys.join('+')}
            className="flex items-center justify-between gap-4 py-2"
          >
            <dt className="text-sm text-foreground">{shortcut.label}</dt>
            <dd className="inline-flex shrink-0 items-center gap-1">
              {shortcut.keys.map((key, index) => (
                <Kbd key={`${key}-${index}`}>{key}</Kbd>
              ))}
            </dd>
          </div>
        ))}
      </dl>
      <p className="mt-3 text-xs text-muted-foreground">
        Os atalhos não funcionam enquanto você digita num campo — a não ser o ⌘K (Ctrl+K).
      </p>
    </Dialog>
  );
}
